module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_13_m2.bde333042d127d5d93049d524efbe3cc.png";